// extracted by mini-css-extract-plugin
export default {"historyCol":"style__historyCol__QFJNM","historyColLarge":"style__historyColLarge__yC7Mn style__historyCol__QFJNM","historyLink":"style__historyLink__s_Sia"};